//
// HEI.Menu object constructor
//
// Object constructor for a menu control
// which is like a file menu
//
// Ben Ramey
// July 2009
//
HEIJS.JavascriptMenu = function(container)
{
  this.container = container;
  this.baseMenu = $("ul.hei-basejavascriptmenu", this.container);
  
  this.menuItemPathCache = {};

  this.setupEvents();
};

HEIJS.JavascriptMenu.prototype =
{
  //
  // Properties
  //
  container: null,
  baseMenu: null,
  activeMenu: null,
  altKeyIsDown: false,
  menuItemPathCache: null,

  //
  // Methods
  //
  setupEvents: function ()
  {
    var self = this;

    // menu item clicks
    this.baseMenu.children("li")
      .bind("click", this, this.handleBaseMenuItemClick);

    this.baseMenu.children("li").find("li.hei-javascriptmenu-item")
      .bind("click", this, this.handleSubMenuItemClick);

    // keystrokes for menu items
    $(document).bind("keypress", this, this.handleKeyPress);
  },

  attachEvent: function (menuItemPath, jqueryEventFunction, jqueryEventData)
  {
    var menuItems = this.getMenuItemsFromPath(menuItemPath);
    menuItems.bind("click", jqueryEventData, jqueryEventFunction);
  },

  disableItem: function (menuItemPath)
  {
    var menuItems = this.getMenuItemsFromPath(menuItemPath);
    menuItems.addClass("hei-javascriptmenu-item-disabled");
  },

  enableItem: function (menuItemPath)
  {
    var menuItems = this.getMenuItemsFromPath(menuItemPath);
    menuItems.removeClass("hei-javascriptmenu-item-disabled");
  },

  setItemImage: function (menuItemPath, imageUrl)
  {
    var menuItems = this.getMenuItemsFromPath(menuItemPath);
    menuItems.css("background-image", "url(" + imageUrl + ")");
  },

  removeItemImage: function (menuItemPath)
  {
    var menuItems = this.getMenuItemsFromPath(menuItemPath);
    menuItems.css("background-image", "");
  },

  hasItemImage: function (menuItemPath)
  {
    var menuItems = this.getMenuItemsFromPath(menuItemPath);

    if (menuItems.css("background-image") == ""
        || menuItems.css("background-image") == "none")
      return false;
    else
      return true;
  },

  closeMenu: function ()
  {
    this.baseMenu.children("li:has(ul:visible)").click();
  },

  getMenuItemsFromPath: function (path)
  {
    if (typeof (this.menuItemPathCache[path]) != "undefined")
      return this.menuItemPathCache[path];

    var pathParts = path.split("/");
    var base = this.baseMenu;

    for (var idx = 0; idx < pathParts.length; idx++)
    {
      if (base.is("li"))
        base = base.children("ul.hei-subjavascriptmenu");

      if (pathParts[idx] == "*")
        base = base.children("li.hei-javascriptmenu-item");
      else
        base = base.children("li.hei-javascriptmenu-item[text='" + pathParts[idx] + "']");

      if (base.length <= 0)
        break;
    }

    this.menuItemPathCache[path] = base;
    return base;
  },

  handleSubMenuItemClick: function (e)
  {
    var self = e.data;
    var subMenu = $(this).children("ul.hei-subjavascriptmenu");

    if (subMenu.length > 0)
      subMenu.toggle();

    // this prevents any events that have been attached to
    // clicking this menu item from being triggered
    if ($(this).is(".hei-javascriptmenu-item-disabled"))
      e.stopImmediatePropagation();

    e.stopPropagation();
  },

  handleBaseMenuItemClick: function (e)
  {
    var self = e.data;
    var nonClickedMenus = $("li.hei-javascriptmenu-item").not(this);
    var subMenu = $(this).children("ul.hei-subjavascriptmenu");

    if ($(this).is(".hei-javascriptmenu-item-disabled"))
      return;

    nonClickedMenus
      .removeClass("hei-javascriptmenu-item-selected")
      .children("ul.hei-subjavascriptmenu")
      .hide();
    subMenu.toggle();

    if (subMenu.css("display") == "block")
    {
      self.activeMenu = subMenu;
      $(this).addClass("hei-javascriptmenu-item-selected");
      $("li.hei-javascriptmenu-item").bind("mouseenter", self, self.handleMenuItemHover);
      $(document).bind("click.menuitem", self, self.handleBaseMenuItemClick);
    }
    else
    {
      self.activeMenu = subMenu.parents("ul.hei-subjavascriptmenu");
      $(this).removeClass("hei-javascriptmenu-item-selected");
      $("li.hei-javascriptmenu-item").unbind("mouseenter");
      $(document).unbind("click.menuitem");
    }

    e.stopPropagation();
  },

  handleMenuItemHover: function (e)
  {
    var nonHoveredMenus = $("li.hei-javascriptmenu-item").not(this).not($(this).parents("li.hei-javascriptmenu-item"));
    var subMenu = $(this).children("ul.hei-subjavascriptmenu");

    if ($(this).is(".hei-javascriptmenu-item-disabled"))
      return;

    if (!$(this).hasClass("hei-javascriptmenu-item-selected"))
    {
      nonHoveredMenus
        .removeClass("hei-javascriptmenu-item-selected")
        .children("ul.hei-subjavascriptmenu")
        .hide();
      subMenu.toggle();
    }

    if (subMenu.css("display") == "block")
    {
      $(this).addClass("hei-javascriptmenu-item-selected");
    }

    e.stopPropagation();
  },

  handleKeyPress: function (e)
  {
    // we only care about letters here
    if ((!(65 <= e.which && e.which <= 65 + 25)
            && !(97 <= e.which && e.which <= 97 + 25))
          || $(e.target).is("input[type=text],textarea,select"))
    {
      return;
    }

    var self = e.data;
    var activeMenu = self.activeMenu && self.activeMenu.length > 0 ? self.activeMenu : self.baseMenu;
    var activeMenuMenuItems = activeMenu.children("li.hei-javascriptmenu-item");

    activeMenuMenuItems.each(
      function (i, d)
      {
        var keyCode = $(this).attr("keycommand");
        if (e.which == keyCode)
        {
          $(this).click();
          return false; // breaks out of "each" loop
        }
      }
    );
  }
};